// extracted by mini-css-extract-plugin
module.exports = {"container":"Cards_container__1Qa2s","card":"Cards_card__3yo-R","infected":"Cards_infected__24K3P","recovered":"Cards_recovered__2rXQ1","deaths":"Cards_deaths__2j9c6"};